import { createStore } from 'vuex'
import auth from "@/store/common/auth"
import customer from "@/store/common/customer"
import form from "@/store/common/form"

import config from "./portal_config"
import invoice from "./invoice"
import subData from "./sub_data"
import changeOrder from './change-order'
import { enableVuexSoftReports, getVuexStrictMode } from '@/utils/vuex-soft-strict'

const store = createStore({
  modules: {
    customer,
    form,
    auth,
    config,
    invoice,
    subData,
    changeOrder
  },
  strict: getVuexStrictMode()
});

enableVuexSoftReports(store, { storeName: 'portal' });

export default store;
